export default "__VITE_ASSET__BiC3MoRS__"